module.exports = __webpack_public_path__ + "static/media/atendance_clear.92e6e916.svg";